module.exports = __webpack_public_path__ + "static/media/Spinner2.0d0c2e94.gif";